import { RouteRecordRaw } from 'vue-router'
const Users = () =>
  import(/* webpackChunkName: "users-view" */ '@/pages/users/index.vue')
const Proucts = () =>
  import(/* webpackChunkName: "products-view" */ '@/pages/products/index.vue')
const Lessons = () =>
  import(/* webpackChunkName: "lessons-view" */ '@/pages/lessons/index.vue')
const Orders = () =>
  import(/* webpackChunkName: "lessons-view" */ '@/pages/orders/index.vue')
const DashboardLayout = () =>
  import(
    /* webpackChunkName: "dashboard-layout" */ '@/layouts/DashboardLayout.vue'
  )

export const dashboardRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: { name: 'lessons' },
    component: DashboardLayout,
    meta: {
      auth: true,
    },
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        redirect: { name: 'lessons' },
        meta: {
          auth: {
            roles: 'admin',
            redirect: '/auth/login',
            notFoundRedirect: { name: '404' },
            forbiddenRedirect: '/404',
          },
        },
      },
      {
        path: '/users',
        name: 'users',
        component: Users,
        meta: {
          auth: {
            roles: 'admin',
            redirect: '/auth/login',
            notFoundRedirect: { name: '/404' },
            forbiddenRedirect: '/404',
          },
        },
      },
      {
        path: '/lessons',
        name: 'lessons',
        component: Lessons,
        meta: {
          auth: {
            roles: ['admin', 'coach'],
            redirect: '/auth/login',
            notFoundRedirect: { name: '404' },
            forbiddenRedirect: '/404',
          },
        },
      },
      {
        path: '/orders',
        name: 'orders',
        component: Orders,
        meta: {
          auth: {
            roles: ['admin'],
            redirect: '/auth/login',
            notFoundRedirect: { name: '404' },
            forbiddenRedirect: '/404',
          },
        },
      },
      {
        path: '/products',
        name: 'products',
        component: Proucts,
        meta: {
          auth: {
            roles: ['admin'],
            redirect: '/auth/login',
            notFoundRedirect: { name: '404' },
            forbiddenRedirect: '/404',
          },
        },
      },
    ],
  },
]
